export default __webpack_public_path__ + "static/media/potential-outage-secondary-portrait.47c86888.jpg";